/** управление пользователями
 */
import _ from "lodash";
import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { Error400 } from "views/pages/index";
import PageTitle, { BreadCrumbs } from "components/standart/PageTitle";
import IntlMessages from "util/intlMessages";
import { path } from "./init";
import UsersTable from "./UsersTable";
import UserInfo from "./UserInfo";
import AddUser from "./AddUser";

const Users = (props) => {
  const { url, path } = useRouteMatch();
  const { breadCrumbs = new BreadCrumbs() } = props;

  breadCrumbs.push({
    title: <IntlMessages id="Users" />,
    url,
    actions: [<AddUser />],
  });

  return (
    <div className="react-strap-doc">
      <Switch>
        <Route exact path={`${path}`}>
          <PageTitle {...breadCrumbs} />

          <UsersTable />
        </Route>

        <Route path={`${path}/user_:userId`}>
          <UserInfo {...{ breadCrumbs }} />
        </Route>

        <Route component={Error400} />
      </Switch>
    </div>
  );
};

export default { path, component: Users };
